"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _lodash = require("lodash");
var maskValue = function maskValue(value, format) {
  if (!value) {
    return '';
  }
  var reg = /\W/g;
  var newValue = value.replace(reg, '');
  var res = reg.exec(format);
  while (res !== null) {
    if (value.length > res.index) {
      newValue = (0, _lodash.join)((0, _lodash.concat)((0, _lodash.slice)(newValue, 0, res.index), res, (0, _lodash.slice)(newValue, res.index)), '');
    }
    res = reg.exec(format);
  }
  return newValue;
};
var _default = maskValue;
exports["default"] = _default;